import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'

import usePostTrialApplyStepViewedEvent from '@components/hooks/usePostTrialApplyStepViewedEvent'
import { Text } from '@components/primitives/Text'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import debounce from 'lodash/debounce'
import { useCallback, useState } from 'react'
import InformedConsentScroller from './InformedConsentScroller'

export function PatientRegistryEnrollmentPrompt({
  idToken: trialApplicationIdToken,
}: ApplySuccessPageProps) {
  usePostTrialApplyStepViewedEvent({
    trialApplicationIdToken,
    type: 'registry-self-enrollment',
  })

  const [hasScrolled, setHasScrolled] = useState<boolean>(false)

  const trackScroll = useCallback(() => {
    if (hasScrolled) {
      return
    }
    trackEvent(TrackingEvents.PATIENT_REGISTRY_ENROLLMENT_CONSENT_SCROLLED, {
      source: TrackingSources.TRIAL_APPLICATION_FORM,
    })
    setHasScrolled(true)
  }, [hasScrolled, setHasScrolled])
  const debouncedTrackScroll = debounce(trackScroll, 500)

  return (
    <div className='mx-auto max-w-3xl'>
      <div className='grid grid-cols-1 gap-6'>
        <div className='grid grid-cols-1 gap-4'>
          <Text element='h1' styleName='h3'>
            Would you like researchers to be able to contact you about other
            trials?
          </Text>
          <Text className='text-neutral500' element='h2' styleName='p-small'>
            If you would like, you can choose to be a volunteer participant in
            the Power Local Patients Registry. Please read the volunteer
            agreement below for more detail on what participation entails.
          </Text>
        </div>
        <div className='grid grid-cols-1 gap-4'>
          <InformedConsentScroller onScroll={debouncedTrackScroll} />
        </div>
      </div>
    </div>
  )
}
